export default {"src":"/_next/static/media/coinbase.41d2d6cf.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};